import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnswersService } from '../services/answers.service';
import { QuestionsService } from '../services/questions.service';

@Component({
  selector: 'app-confirmdialog',
  templateUrl: './confirmdialog.component.html',
  styleUrls: ['./confirmdialog.component.css']
})
export class ConfirmdialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ConfirmdialogComponent>,@Inject(MAT_DIALOG_DATA) public data: any,
  private questionService: QuestionsService, private answerService: AnswersService) { }

  ngOnInit() {
    //console.log(this.data);
  }

  close() {
      this.dialogRef.close();
  }

  update(val){
    if(this.data.type == "Question"){
      this.questionService.updateQuestion(this.data.question, val.value).subscribe(res=>{
       // console.log(res);
      });
    }
    else if(this.data.type == "Answer"){
      this.answerService.updateAnswer(this.data.answer, val.value).subscribe(res=>{
       // console.log(res);
      });
    }
    else if(this.data.type == "Comment"){
      this.answerService.updateComment(this.data.comment, val.value).subscribe(res=>{
       // console.log(res);
      });
    }
    //console.log("Update");
    this.dialogRef.close();
  }
}
